import { StyledLoan1003LayoutContainer } from '../common/components/StyledComponents';
import { useBorrower1003Store } from './borrower1003Store';
import { BorrowerCrudGrid } from './components/BorrowerCrudGrid';
import { BorrowerForm } from './components/forms/BorrowerForm';

export function Borrower1003() {
  return (
    <StyledLoan1003LayoutContainer sx={{ gap: '2rem' }}>
      <BorrowerCrudGrid />
      <Borrower1003FormContainer />
    </StyledLoan1003LayoutContainer>
  );
}

function Borrower1003FormContainer() {
  const { selectedBorrowerId } = useBorrower1003Store();

  if (!selectedBorrowerId) {
    return null;
  }

  return (
    <BorrowerForm key={selectedBorrowerId} borrowerId={selectedBorrowerId} />
  );
}
